<template>
  <span>
    <span>是否对外发布</span>
    <el-popover
      placement="top"
      title=""
      width="700"
      trigger="hover"
    >
      <i slot="reference" class="el-icon-question text-primary font-16 m-l-4"></i>
      <div class="tip-content">
        <div>对外发布平台：</div>
        <div>1）<span class="text-color text-bold">云采购门户</span>，默认展示所有单位发布的公示、公告。</div>
        <div>2）<span class="text-color text-bold">江西省国有企业采购交易服务平台</span>， 仅展示国资监管单位发布的公示、公告。</div>
        <div>3）<span class="text-color text-bold">中国招投标公共服务平台</span>，发布项目时如果勾选发布到该平台则后续的公告公示都会在该平台展示。</div>
        <div class="text-color text-bold m-t-20">如果不对外发布则以上平台都不展示。</div>
      </div>
    </el-popover>
  </span>
</template>

<script>
export default {
  name: 'ReleaseNoticeCopyWriter'
}
</script>

<style scoped lang="scss">
.tip-content {
  color: $second-text-color;
  font-size: 14px;
  line-height: 20px;
}
</style>